import {resolveBackground} from '#core/utils/color-utils.js';
import {merge} from '#core/utils/config-utils.js';

import {Intents} from '#core/application/intents/index.js';

import {generatePivotButton} from '#core/application/modules/tiles/pivot/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';
import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';
import {generateViewSwitcher} from '#core/application/modules/tiles/view-switcher/index.js';
import {generateYourBet} from '#core/application/modules/tiles/your-bet/index.js';

export function yourBetsFactory(PALETTE) {
    const YOUR_BETS_BET = merge(generateYourBet(PALETTE.YOUR_BETS_BET), {
        container: {
            style: {
                _desktop_maxWidth: 288, // this is AppViewSportsbook.sideMenuContainer.style.width - OpenBetsView.betContainer.style.padding
                boxSizing: 'border-box',
            },
        },
    });
    const YOUR_BETS_FILTER_VIEW_SWITCHER = generateViewSwitcher(PALETTE.YOUR_BETS_FILTER_VIEW_SWITCHER);
    const YOUR_BETS_BET_SKELETON_PART = generateSkeletonPart(PALETTE.YOUR_BETS_BET_SKELETON_PART);

    return {
        YourBets: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.YOUR_BETS_CONTAINER_BG),
                },
            },
            tabs: {
                container: {
                    style: {
                        padding: '0 0 8px',
                    },
                },
                tabButtons: {
                    container: {
                        style: {
                            padding: '0 0 8px',
                        },
                    },
                    selectableButton: generatePivotButton(PALETTE.YOUR_BETS_TAB_SELECTOR),
                },
            },
            loginInvitationContainer: {
                style: {
                    flexBasis: '112px',
                },
            },
            loginInvitationText: {
                style: {
                    ...PALETTE.YOUR_BETS_EMPTY_CONTENT_MESSAGE.EMPTY_CONTENT_MESSAGE_TEXT,
                },
            },
            allBetsContainer: {
                style: {
                    padding: '4px 0 0 0',
                    margin: '8px 0 0',
                },
            },
            betList: {
                emptyBetsText: {
                    style: {
                        ...PALETTE.YOUR_BETS_EMPTY_CONTENT_MESSAGE.EMPTY_CONTENT_MESSAGE_TEXT,
                    },
                },
                betHistoryButton: {
                    ...(!Intents.BET_HISTORY
                        ? {
                              button: {
                                  style: {
                                      base: {
                                          display: 'none',
                                      },
                                  },
                              },
                          }
                        : {}),
                    buttonLabel: {
                        style: PALETTE.YOUR_BETS_BET_HISTORY_LINK.SECONDARY_LINK_TEXT,
                    },
                    buttonIcon: {
                        style: {
                            fill: PALETTE.YOUR_BETS_BET_HISTORY_LINK.SECONDARY_LINK_ICON_COLOR,
                        },
                    },
                },
                betHistoryButtonIntent: Intents.BET_HISTORY,
                betView: YOUR_BETS_BET,
                savedBetView: YOUR_BETS_BET,
                removeBetAlert: {
                    container: {
                        style: {
                            ...resolveBackground(PALETTE.REMOVE_BET_ALERT_BG),
                            borderRadius: PALETTE.REMOVE_BET_ALERT_BORDER_RADIUS,
                            padding: 0,
                        },
                    },
                    style: {
                        messageText: {
                            ...PALETTE.REMOVE_BET_ALERT_MESSAGE_TEXT,
                        },
                    },
                    buttonsConfig: {
                        cancel: {
                            button: generateSecondaryButton(PALETTE.REMOVE_BET_ALERT_BUTTON_CANCEL),
                        },
                        confirm: {
                            button: generatePrimaryButton(PALETTE.REMOVE_BET_ALERT_BUTTON_CONFIRM),
                        },
                    },
                },
                toggleButtonContainer: {
                    style: {
                        padding: 0,
                    },
                },
                toggleMenuContainer: YOUR_BETS_FILTER_VIEW_SWITCHER.switcherContainer,
                toggleButton: YOUR_BETS_FILTER_VIEW_SWITCHER.switcherButton,
                searchInput: merge(generateSearchInput(PALETTE.YOUR_BETS_FILTER_SEARCH_INPUT), {
                    container: {
                        base: {
                            style: {
                                height: 40,
                            },
                        },
                        active: {
                            style: {
                                _desktop_width: 'initial',
                            },
                        },
                        inactive: {
                            style: {
                                _desktop_width: 'initial',
                            },
                        },
                    },
                }),
            },
        },
        // skeleton
        OpenBetsSkeleton: {
            container: {
                style: {
                    padding: '4px 8px',
                },
            },
            betContainer: YOUR_BETS_BET.container,
            tabLabel: YOUR_BETS_BET_SKELETON_PART,
            filtersPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            betTitlePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            betDatePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            betStatusPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            legStatusIconPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            selectionNamePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            marketNamePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            eventNamePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            eventDatePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            oddsPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            stakeTextPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            stakeValuePlaceholder: YOUR_BETS_BET_SKELETON_PART,
            payoutTextPlaceholder: YOUR_BETS_BET_SKELETON_PART,
            payoutValuePlaceholder: YOUR_BETS_BET_SKELETON_PART,
        },
    };
}
